<div class="circular-progress" [style]="{ background: color() }" #circularProgress>
  <span class="progress-value" [style]="{ color: color(), 'font-size': text() ? '10px' : '12px' }"></span>
</div>
